import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "content ta-center mb-24" }
const _hoisted_3 = { class: "d-flex justify-content-between" }
const _hoisted_4 = {
  key: 0,
  class: "info"
}
const _hoisted_5 = {
  key: 1,
  class: "info"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "title ta-center mb-6" }, "Result of Review", -1)),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.message), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_BaseButton, {
        class: "mb-20",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onSendSummary')))
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("Send summary", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_BaseButton, { class: "mb-20" }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode("No, don't send", -1)
        ]))]),
        _: 1
      })
    ]),
    (_ctx.rejected === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, " This email will be sent directly to the partner as confirmation of this approval and will be delivered immediately. "))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, " This action sends the partner an email reminder with a secure link to updated only the questions you rejected. If you select 'Yes', the email will be sent immediately. "))
  ]))
}